import { FC } from 'react'

import { ISvgClass } from '../interface'

const ChevronRightIcon: FC<ISvgClass> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M9.4 18L8 16.6L12.6 12L8 7.4L9.4 6L15.4 12L9.4 18Z"
        fill="inherit"
      />
    </svg>
  )
}

export default ChevronRightIcon
